"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionFormMigrateModalCtrl = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const services_1 = require("../../services");
const page_state_1 = require("../../state/page.state");
const store_1 = require("../../store");
class CollectionFormMigrateModalCtrl {
    constructor(collections) {
        this.failures = [];
        this.updatingForm = false;
        this.collections = collections;
    }
    updateFormCollections(targetFormVersion) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.setUpdatingForm(true);
            const collectionUuids = this.collections.map(c => c.uuid);
            yield services_1.Services.Department.rest.Collection.migrate({
                collections: collectionUuids.map(uuid => ({ uuid })),
                targetFormVersion
            });
            yield page_state_1.CurrentState.updateInspectedCollection();
            yield this.refresh(collectionUuids);
            this.setUpdatingForm(false);
        });
    }
    refresh(collectionUuids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const collectionSummaries = yield Promise.all(collectionUuids.map(uuid => store_1.AppStore.CollectionSummary.getFetchableByUuid(uuid).refetch()));
            return Promise.all([
                store_1.AppStore.Tag.refresh(),
                ...this.getTagIds(collectionSummaries).map(tagId => store_1.AppStore.TagSummary.getFetchable(tagId).refetch())
            ]);
        });
    }
    getTagIds(collectionSummaries) {
        const tags = {};
        for (const collectionSummary of collectionSummaries) {
            for (const tag of collectionSummary.tags) {
                if (!tags[tag] && !(0, core_api_1.isSystemTag)(tag)) {
                    tags[tag] = true;
                }
            }
        }
        return Object.keys(tags);
    }
    setUpdatingForm(updatingForm) {
        this.updatingForm = updatingForm;
    }
}
exports.CollectionFormMigrateModalCtrl = CollectionFormMigrateModalCtrl;
tslib_1.__decorate([
    mobx_1.observable
], CollectionFormMigrateModalCtrl.prototype, "updatingForm", void 0);
tslib_1.__decorate([
    mobx_1.action
], CollectionFormMigrateModalCtrl.prototype, "setUpdatingForm", null);
//# sourceMappingURL=collection.form.migrate.modal.ctrl.js.map